"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/testimonialsSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TestimonialsSectionFaSolidFaStarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star" | "fa-solid fa-star text-light" */
    className: string;
};

type TestimonialsSectionHorizontalSlideSlideThreesItem = {
    key: Key | null | undefined;
    /** Detected variants: "true" */
    dataAnimated?: boolean;
    /** Detected variants: "left" | "right" */
    dataDirection: string;
    /** Detected variants: "horizontal-slide slide-three d-flex" */
    className?: string;
    /** Detected variants: "slow" */
    dataSpeed?: string;
    slideListItems?: TestimonialsSectionServicesSlides2Item[];
};

type TestimonialsSectionServicesSlides2Item = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/patients/patient2.jpg" | "/Templates/Doccure/img/patients/patient1.jpg" | "/Templates/Doccure/img/patients/patient3.jpg" | "/Templates/Doccure/img/patients/patient4.jpg" | "/Templates/Doccure/img/patients/patient6.jpg" | "/Templates/Doccure/img/patients/patient11.jpg" | "/Templates/Doccure/img/patients/patient7.jpg" */
    src: string;
    /** Detected variants: "Gregg Lewis" | "Sarah Mitchell" | "Jonathan Brooks" | "Lauren Parker" | "Michael Adams" | "Andrew Cooper" */
    h30Text: ReactNode;
    /** Detected variants: "San Diego, CA" | "Austin, TX" | "Miami, FL" | "Seattle, WA" | "Chicago, IL" | "Nashville, TN" */
    p0Text: ReactNode;
    /** Detected variants: "fa-solid fa-star" | "fa-solid fa-star text-light" */
    className: string;
    /** Detected variants: "Absolutely amazing with kids. She keeps my children calm and comfortable during every visit. The office is bright, fun, and welcoming, making dental care." | "Incredible throughout my orthodontic treatment. She explained everything clearly, made adjustments carefully, and ensured comfort." | "Dr. Ross provided the best dental implant experience I’ve ever had. From consultation to recovery, everything was smooth. My new teeth look natural." | "Dr. Kim completely transformed my smile with veneers. His attention to detail is unmatched. I love the natural results and receive constant compliments." | "Very gentle and reassuring during my wisdom tooth extraction. The procedure was quick, recovery was easy, and her staff was amazing so wonderful job your team." | "Aligner treatment exceeded my expectations. He created a personalized plan that worked perfectly for me. The results are incredible so wonderful job your team." */
    p0P0Text: ReactNode;
    /** Detected variants: "services-slide" */
    divClassName?: string;
    /** Detected variants: "testimonial-item-three" */
    div0ClassName?: string;
    /** Detected variants: "testimonial-author" */
    div0ClassName2?: string;
    /** Detected variants: "testimonial-avatar" */
    div0ClassName3?: string;
    /** Detected variants: "patient1" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "author" */
    div1ClassName?: string;
    /** Detected variants: "custom-title author-name" */
    h30ClassName?: string;
    /** Detected variants: "author-location" */
    p0ClassName?: string;
    /** Detected variants: "testimonial-content" */
    div1ClassName2?: string;
    /** Detected variants: "review" */
    div0ClassName4?: string;
    /** Detected variants: "fa-solid fa-star" */
    i0ClassName?: string;
    /** Detected variants: "fa-solid fa-star" */
    i1ClassName?: string;
    /** Detected variants: "fa-solid fa-star" */
    i2ClassName?: string;
    /** Detected variants: "fa-solid fa-star" */
    i3ClassName?: string;
    /** Detected variants: "true" */
    ariaHidden?: boolean;
    reviewItems?: TestimonialsSectionFaSolidFaStars9Item[];
};

type TestimonialsSectionFaSolidFaStars9Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star" | "fa-solid fa-star text-light" */
    className: string;
};
export type HomeThreeTestimonialsSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialsSectionServicesSlides2Item) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialsSectionServicesSlides2Item) => Partial<ComponentProps<"h3">>);
    /** Default: "fade-up" */
    sectionDiv0Div0DivDataAos?: string;
    /** Default: "Testimonials" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Feedback from Our Clients" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Discover what our patients have to say about their dental experiences." */
    sectionDiv0Div0P0PText?: ReactNode;
    /** Default: "service-element-1" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/service-element-1.svg" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    testimonialsSectionFaSolidFaStars: TestimonialsSectionFaSolidFaStarsItem[];
    testimonialsSectionHorizontalSlideSlideThrees: TestimonialsSectionHorizontalSlideSlideThreesItem[];
    testimonialsSectionFaSolidFaStarsItemWrapper?: (item: TestimonialsSectionFaSolidFaStarsItem, content: ReactNode) => ReactNode;
    testimonialsSectionFaSolidFaStarsRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialsSectionHorizontalSlideSlideThreesItemWrapper?: (item: TestimonialsSectionHorizontalSlideSlideThreesItem, content: ReactNode) => ReactNode;
    testimonialsSectionHorizontalSlideSlideThreesRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialsSectionServicesSlides2ItemWrapper?: (item: TestimonialsSectionServicesSlides2Item, content: ReactNode) => ReactNode;
    testimonialsSectionServicesSlides2Renderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialsSectionServicesSlides2ImageVisible?: boolean;
    testimonialsSectionServicesSlides2ImageRenderer?: (item: TestimonialsSectionServicesSlides2Item, defaultNode: ReactNode) => ReactNode;
    testimonialsSectionServicesSlides2H3Visible?: boolean;
    testimonialsSectionServicesSlides2H3Renderer?: (item: TestimonialsSectionServicesSlides2Item, defaultNode: ReactNode) => ReactNode;
    testimonialsSectionServicesSlides2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialsSectionServicesSlides2Item) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialsSectionServicesSlides2H3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialsSectionServicesSlides2Item) => Partial<ComponentProps<"h3">>);
    testimonialsSectionFaSolidFaStars9ItemWrapper?: (item: TestimonialsSectionFaSolidFaStars9Item, content: ReactNode) => ReactNode;
    testimonialsSectionFaSolidFaStars9Renderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeThreeTestimonialsSectionGenerated: FC<HomeThreeTestimonialsSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Testimonials",
    sectionDiv0Div0DivDataAos = "fade-up",
    sectionDiv0Div0H20H2Text = "Feedback from Our Clients",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "Discover what our patients have to say about their dental experiences.",
    sectionImageWithBasePath0ImageAlt = "service-element-1",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/service-element-1.svg",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div1H30H3Props,
    testimonialsSectionFaSolidFaStars,
    testimonialsSectionHorizontalSlideSlideThrees,
    testimonialsSectionFaSolidFaStarsItemWrapper,
    testimonialsSectionFaSolidFaStarsRenderer,
    testimonialsSectionHorizontalSlideSlideThreesItemWrapper,
    testimonialsSectionHorizontalSlideSlideThreesRenderer,
    testimonialsSectionServicesSlides2ItemWrapper,
    testimonialsSectionServicesSlides2Renderer,
    testimonialsSectionServicesSlides2ImageVisible,
    testimonialsSectionServicesSlides2ImageRenderer,
    testimonialsSectionServicesSlides2H3Visible,
    testimonialsSectionServicesSlides2H3Renderer,
    testimonialsSectionServicesSlides2ImageProps,
    testimonialsSectionServicesSlides2H3Props,
    testimonialsSectionFaSolidFaStars9ItemWrapper,
    testimonialsSectionFaSolidFaStars9Renderer,
}) => {
    return (
        <section className="testimonial-section testimonial-section-three section">
            <div className="container">
                <div className="section-header section-header-three text-center aos" data-aos={sectionDiv0Div0DivDataAos}>
                    <div className="title">
                        <i className="fa-solid fa-circle" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    <p className="subtitle">{sectionDiv0Div0P0PText}</p>
                </div>
            </div>
            {renderCollectionNode(
                testimonialsSectionHorizontalSlideSlideThrees,
                (item: TestimonialsSectionHorizontalSlideSlideThreesItem) => (
                    <div className={item.className ?? "horizontal-slide slide-three d-flex"} data-direction={item.dataDirection} data-speed={item.dataSpeed ?? "slow"} data-animated={item.dataAnimated} key={item.key}>
                        <div className="slide-list d-flex gap-4">
                            {renderCollectionNode(
                                item.slideListItems ?? [],
                                (item: TestimonialsSectionServicesSlides2Item) => (
                                    <div className={item.divClassName ?? "services-slide"} aria-hidden={item.ariaHidden ?? "true"} key={item.key}>
                                        <div className={item.div0ClassName ?? "testimonial-item-three"}>
                                            <div className={item.div0ClassName2 ?? "testimonial-author"}>
                                                <div className={item.div0ClassName3 ?? "testimonial-avatar"}>
                                                    {renderItemNode(testimonialsSectionServicesSlides2ImageVisible, testimonialsSectionServicesSlides2ImageRenderer, item, (
                                                        <SmartImage src={item.src} alt={item.alt ?? "patient1"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof testimonialsSectionServicesSlides2ImageProps === "function" ? testimonialsSectionServicesSlides2ImageProps(item) : (testimonialsSectionServicesSlides2ImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </div>
                                                <div className={item.div1ClassName ?? "author"}>
                                                    {renderItemNode(testimonialsSectionServicesSlides2H3Visible, testimonialsSectionServicesSlides2H3Renderer, item, (
                                                        <h3 className={item.h30ClassName ?? "custom-title author-name"} {...(typeof testimonialsSectionServicesSlides2H3Props === "function" ? testimonialsSectionServicesSlides2H3Props(item) : (testimonialsSectionServicesSlides2H3Props ?? {}))} {...(typeof divDiv0Div0Div1H30H3Props === "function" ? divDiv0Div0Div1H30H3Props(item) : (divDiv0Div0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                    ))}
                                                    <p className={item.p0ClassName ?? "author-location"}>{item.p0Text}</p>
                                                </div>
                                            </div>
                                            <div className={item.div1ClassName2 ?? "testimonial-content"}>
                                                <p>{item.p0P0Text}</p>
                                                <div className={item.div0ClassName4 ?? "review"}>
                                                    {renderCollectionNode(
                                                        item.reviewItems ?? [],
                                                        (item: TestimonialsSectionFaSolidFaStars9Item) => (
                                                            <i className={item.className} key={item.key} />
                                                        ),
                                                        testimonialsSectionFaSolidFaStars9ItemWrapper,
                                                        testimonialsSectionFaSolidFaStars9Renderer
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ),
                                testimonialsSectionServicesSlides2ItemWrapper,
                                testimonialsSectionServicesSlides2Renderer
                            )}
                        </div>
                    </div>
                ),
                testimonialsSectionHorizontalSlideSlideThreesItemWrapper,
                testimonialsSectionHorizontalSlideSlideThreesRenderer
            )}
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeThreeTestimonialsSectionGenerated;
